import React from 'react';
import PropTypes from 'prop-types';
import { handleResourceUrl } from '../../../utils';
import { imageConfig } from '../../../config/image';
import './image.less';

export default class Image extends React.PureComponent {
  static getUrl = (options = {}) => {
    const { id, src } = options;
    // const { appConfig } = options;

    let _src = '';

    if (src) {
      _src = src;
    }

    if (id) {
      // 先从本地默认配置拿图片， 再看服务器配置有没有
      // 最后设置图片地址
      const _configSrc = imageConfig[id];
      // _configSrc = getDeepValue(appConfig, `images.${id}`) || _configSrc

      _src = _configSrc ? _configSrc : _src;
    }

    _src = handleResourceUrl(_src);

    return (_src || '').replace(/\s/g, encodeURIComponent(' '));
  };

  static contextTypes = {
    appConfig: PropTypes.object,
  };

  static defaultProps = {
    // src和id二选一
    //
    // src直接指定路径
    // id 会优先在服务器images配置里找， 没有的话就在本地默认图片配置里找
    src: '',
    id: '',
    width: null,
    height: null,
    size: null,
    className: '',
    style: {},
    onClick: null,
    tag: 'div', // img, div
    showAfterLoaded: false,
  };

  get params() {
    const {
      src,
      id,
      width,
      height,
      size,
      style,
      tag,
      onClick,
      className,
      showAfterLoaded,
      onLoad,
      ...extra
    } = this.props;

    const _params = {
      style: {},
      onClick,
      className: `xsdj-image ${tag === 'img' ? 'tag-img' : ''} ${className}`,
      ...extra,
    };
    const _src = Image.getUrl({ id, src, appConfig: this.context.appConfig });

    if (size !== null) {
      _params.style.width = size;
      _params.style.height = size;
    }

    if (width !== null) {
      _params.style.width = width;
    }

    if (height !== null) {
      _params.style.height = height;
    }

    if (tag === 'img') {
      if (showAfterLoaded) {
        _params.style.opacity = 0;
        _params.style.transition = 'opacity 0.2s linear';
        _params.onLoad = (e = {}) => {
          onLoad && onLoad(e);
          if (e.target) e.target.style.opacity = 1;
        };
      }
      _params.src = _src;
    } else {
      _params.style.backgroundImage = `url(${_src})`;
    }

    Object.assign(_params.style, style);

    return _params;
  }

  render() {
    const { tag, children } = this.props;
    const Tag = tag || 'div';
    return <Tag {...this.params}>{children}</Tag>;
  }
}
